import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import BackButton from '../../common/BackButton'
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/reducers/store';
import { AUTHENTICATED_ROUTES } from '../../../resources/routes-constants';
import { saveDraft, updatePortfolio } from '../../../store/actions/createPortfolio';
import FundFeesSelection from './FundFeesSelection';
import FundFeesProjection from './FundFeesProjection';

const FundFeesStep: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { id } = useParams();
    const dispatch = useAppDispatch();

    const onConfigure = () => {
        dispatch(updatePortfolio({ field: 'step', value: 5 }));
        dispatch(saveDraft()).then(() => {
            navigate((id !== undefined ? AUTHENTICATED_ROUTES.PORTFOLIO_EDIT_STEP_ROUTE.replace(":id", id) : AUTHENTICATED_ROUTES.PORTFOLIO_CREATE_STEP_ROUTE).replace(":step", '5'));
        });
    }

    const onSaveDraft = () => {
        dispatch(saveDraft()).then(() => {
            navigate(AUTHENTICATED_ROUTES.PORTFOLIOS_CONFIRM_SAVE_ROUTE.replace(":confirmSave", "saved"));
        })
    }
    return <Box display={"flex"} flexDirection={"column"} width={"1400px"} gap={"24px"} paddingBottom={"50px"}>
        <Box display={"flex"} width={"100%"}>
            <Box display={"flex"} flexDirection={"column"} alignItems={"start"} flexGrow={1} flexBasis={"45%"} gap={"16px"}>
                <Box display={"flex"} alignItems={"center"} gap={"24px"}>
                    <BackButton />
                    <Typography fontSize={"24px"} fontWeight={"500"} lineHeight={"29.26px"}>{t('CreatePortfolioFeeStructure')}</Typography>
                </Box>
                <FundFeesSelection />
            </Box>
            <Box display={"flex"} flexDirection={"column"} flexGrow={1} flexBasis={"45%"}>
                <FundFeesProjection />
            </Box>
        </Box>
        <Box display={"flex"} width={"100%"} justifyContent={"flex-end"} gap={"16px"}>
            <Button variant='contained' onClick={onConfigure}>{t('CreatePortfolioButtonConfirmNConfigure')}</Button>
            <Button variant='outlined' onClick={onSaveDraft}>{t('CreatePortfolioButtonSaveAsDraft')}</Button>
        </Box>
    </Box>
}

export default FundFeesStep